module.exports = __webpack_public_path__ + "static/media/advertise-here.b1fea8c5.png";